import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";

export default function CompletionRates() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/completion-rates").then((r) => setData(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="completion-rates-page">
      <header>
        <div className="text-[11px] tracking-[0.35em] uppercase text-[#00D4FF]">08 · Completion Rates</div>
        <h1 className="font-heading font-bold text-4xl tracking-tight mt-2">Completion by Department</h1>
      </header>

      <div className="bg-[#12141D] border border-border p-5">
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0}>
            <BarChart data={data} margin={{ top: 20, right: 20, left: 0, bottom: 20 }}>
              <XAxis dataKey="department" stroke="#94A3B8" tick={{ fill: "#94A3B8", fontSize: 11 }} axisLine={{ stroke: "#1E293B" }} />
              <YAxis unit="%" stroke="#94A3B8" tick={{ fill: "#94A3B8", fontSize: 11 }} axisLine={{ stroke: "#1E293B" }} domain={[0, 100]} />
              <Tooltip cursor={{ fill: "rgba(0,212,255,0.08)" }}
                contentStyle={{ background: "#0A0B10", border: "1px solid #1E293B", borderRadius: 0, color: "#F8FAFC" }}
              />
              <Bar dataKey="pct" radius={[0, 0, 0, 0]}>
                {data.map((_, i) => <Cell key={i} fill="#00D4FF" />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {data.map((d) => (
          <div key={d.department} className="bg-[#12141D] border border-border p-4">
            <div className="text-[10px] tracking-[0.25em] uppercase text-muted-foreground">{d.department}</div>
            <div className="font-heading font-bold text-3xl mt-1 tabular-nums">{d.pct}%</div>
            <div className="text-xs text-muted-foreground mt-1">{d.completed}/{d.total} completed</div>
            <div className="h-[2px] w-full bg-[#1A1C28] mt-3">
              <div className="h-full bg-[#00D4FF]" style={{ width: `${d.pct}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
